export default __webpack_public_path__ + "static/media/business-8.1893124c.jpg";